import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {Subscription} from '../classes/subscription';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionsService {

    constructor(private apiService: ApiService) {
    }

    public getSubscriptions() {
        return this.apiService.getCallData$<Subscription[]>('subscriptions');
    }

    public getSubscription(id: number) {
        return this.apiService.getCallData$<Subscription>('subscriptions/' + id);
    }

    save(subscription: Subscription) {
        return this.apiService.postCall$('subscriptions', subscription);
    }

    delete(id: number) {
        return this.apiService.deleteCall(`subscriptions/${id}`);
    }
}
